/**
 * Cambio automático de objetivo (sin DOM: se testea en Node).
 *
 * Cuando el objetivo del autoataque muere o deja de poder atacarse, el héroe
 * pasa al enemigo vivo más cercano dentro de `range` (alcance de ataque + un
 * margen), como el auto-adquirir de LoL. Si no hay ninguno, se suelta.
 */
export interface TargetCandidate {
  id: number;
  pos: { x: number; z: number };
  radius: number;
  alive: boolean;
}

export function nextAutoTarget(
  candidates: readonly TargetCandidate[],
  from: { x: number; z: number },
  range: number,
  excludeId = 0,
): number {
  let best = 0;
  let bestDist = Infinity;
  for (const unit of candidates) {
    if (!unit.alive || unit.id === excludeId) continue;
    const d = Math.hypot(unit.pos.x - from.x, unit.pos.z - from.z) - unit.radius;
    if (d <= range && d < bestDist) {
      best = unit.id;
      bestDist = d;
    }
  }
  return best;
}
